import { Select } from '@chakra-ui/react';
import { ChangeEvent, FC, useMemo } from 'react';
import { Column, Table } from '@tanstack/react-table';

const SelectColumnFilter: FC<{ column: Column<any, any>; table: Table<any>; customOptions?: string[] }> = ({
    column,
    table,
    customOptions,
}) => {
    const preFilteredRows = table.getPreFilteredRowModel().rows;

    const options = useMemo(() => {
        const optionsSet = new Set<string>(customOptions);
        if (!customOptions?.length) {
            preFilteredRows.forEach((row) => {
                const value = row.getValue(column.id);
                if (Array.isArray(value)) {
                    value.forEach((v: string) => optionsSet.add(v));
                } else {
                    optionsSet.add(value as string);
                }
            });
        }

        return [...optionsSet.values()];
    }, [column.id, customOptions, preFilteredRows]);

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        column.setFilterValue(e.target.value || undefined);
    };

    return (
        <Select size="sm" value={(column.getFilterValue() as string) || ''} onChange={handleChange}>
            <option value=""> ALL </option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </Select>
    );
};

export default SelectColumnFilter;
